import React from 'react';
import { Row, Col } from 'antd';
import { Title } from '@/components/Typography';

export function Header() {
	return (
		<Row justify="center" style={{ marginTop: '1rem' }}>
			<Col>
				<Title level={3}>Preliminary Ergonomic Analysis</Title>
			</Col>
		</Row>
	);
}
